import styled, { css } from 'styled-components';

import { Flexer } from '@ontruck/orc';

const borderCss = ({ withBorder }) =>
  withBorder &&
  css`
    border: 8px solid var(--grey300);
    border-radius: 4px;
  `;

const hiddenOption = ({ showHiddenOption }) =>
  showHiddenOption &&
  css`
    display: flex;
    align-items: center;

    label {
      margin-left: 3rem;
    }
  `;

const StyledFilter = styled(Flexer.Child).attrs((props) => ({
  flex: props.grow ? '1' : '0',
  mRight: !props.last && 'S',
}))`
  ${borderCss}
  white-space: nowrap;
  width: auto;
  ${hiddenOption}
`;

export { StyledFilter };
